import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import WorksheetTable from 'components/worksheet/worksheet_table';
import PageTitle from 'components/common/page_title';
import { AppUI, ExerciseUI } from '@seedlang/state';
import { UserWorksheetStore } from '@seedlang/stores';
import eventParamsHelper from 'utils/event_params_helper';
import withRouteParams from 'utils/with_route_params';

const Wrapper = styled.div`
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
`;

@observer
class PodcastWorksheetIndex extends React.Component {
  componentDidMount() {
    AppUI.createEvent('memrev - view podcast', eventParamsHelper());
  }

  getItemRoute = (item) => {
    return {
      name: 'podcast.show',
      params: {
        worksheetId: item.routeId,
      },
    };
  }
  onToggleCompleted = (item) => {
    const newValue = !item.overrideCompleted;
    item.set('overrideCompleted', newValue);
    UserWorksheetStore.updateByWorksheetId({
      ids: { worksheetId: item.id },
      data: { overrideCompleted: newValue },
    });
  }

  render() {
    return (
      <Wrapper>
        <PageTitle>Podcast</PageTitle>
        <WorksheetTable
          showFilters
          headerTitle='Episode'
          defaultWorksheetFilter={{podcast_episode_id: true}}
          store={ExerciseUI.podcastWorksheetStore}
          getItemRoute={this.getItemRoute}
          onToggleCompleted={this.onToggleCompleted}
          {...this.props}
        />
      </Wrapper>
    );
  }
}

export default withRouteParams(ErrorBoundary(PodcastWorksheetIndex));
